export default __webpack_public_path__ + "static/media/negz.616e668f.jpg";